import moment from 'moment';
import React from 'react';
import linkUtils from './linkUtils';

function isInMoreThanOneDayInFuture(date) {
  if (date && moment(date, 'MM/DD/YYYY hh:mm A').isValid()) {
    const now = moment();
    return moment(date, 'MM/DD/YYYY hh:mm A').diff(now, 'days') > -1;
  } else {
    return false;
  }
}

export default {
  getMomentDateByKey(key) {
    const dates = {
      startDate: moment('2016-01-01'),
      currentDate: moment(),
      startOfCurrentMonth: moment().startOf('month'),
      startOfCurrentYear: moment().startOf('year')
    };
    return dates[key];
  },
  getMomentDateByValue(value) {
    return moment(value);
  },
  getMomentEndAndStartDateByMonth(value) {
    return {start: moment(value).startOf('month'), end: moment(value).endOf('month')};
  },
  getMomentEndAndStartDateByYear(value) {
    if (moment(value).year() !== moment().year()) {
      return {
        start: moment(value).startOf('year'),
        end: moment(value).endOf('year')
      };
    } else {
      // this is for YTD meaning the end date should be the current date
      return {start: moment(value).startOf('year'), end: moment()};
    }
  },
  getValueFormDollarizedString(val) {
    if (val) {
      return parseInt(val.split('$')[1].split('.')[0].replace(/,/g, ''), 10);
    } else {
      return 0;
    }
  },
  validateDateStrings(values){
    let possibleErrors = [];
    if (values.length > 0) {
      possibleErrors = values.map(value => {
        if (value.split("/").length !== 3 ||
            value.split("/")[2].length !== 4 ||
            value.split("/")[1].length !== 2 ||
            value.split("/")[0].length !== 2
            ) {
            return 'invalid';
        } else {
          return 'valid';
        }
      });
    }
    return possibleErrors.includes('invalid');
  },

  opportunityActionCellData(rowData) {
    // We cannot use JSX here as the TableBody is using dangerously inner HTML
    // to escape from html entity characters. Since this follows that same code
    // path, we need to send it as raw html.
    const {offer_expires_at, stage, sfid, dba: rawDBA} = rowData;
    const uuid = rowData['salesforce_opportunity_uuid'];
    const isApproved = stage === 'Approval Sent';
    const dba = encodeURIComponent(rawDBA);
    const isNotExpired = isInMoreThanOneDayInFuture(offer_expires_at);

    // NOTE:
    // currently works as well as in prod.
    // need to use partner_action as key
    if (isNotExpired && isApproved) {
      return (
        {
          text: 'Select Terms',
          href: rowData['calculator_url']
        }
      );
    } else if (uuid && rowData['partner_renewal_eligible']) {
      return linkUtils.renewalLink({uuid, dba, source: 'Pipeline'});
    } else if (uuid && rowData['submit_stips_eligible']) {
      return linkUtils.stipsLink({uuid, dba});
    } else {
      return null;
    }
  },

  renewalEligibilityData(rowData) {
    const { partner_renewal_eligible, dba: rawDBA, renewal_eligibility } = rowData;
    const uuid = rowData['salesforce_opportunity_uuid'];

    if (partner_renewal_eligible && uuid) {
      const dba = encodeURIComponent(rawDBA);
      return linkUtils.renewalLink({uuid, dba, source: 'Portfolio'});
    } else {
      return (
        {
          text: renewal_eligibility,
          href: null
        }
      );
    }
  },

  formatDate(date=null) {
    if (date && moment(date).isValid()) {
      return moment(date).startOf('day');
    }
  },

  formatDateToString(date=null) {
    const formattedDate = this.formatDate(date);

    return formattedDate? formattedDate.format('YYYY-MM-DD') : '';
  },

  compactEmptyString(string) {
    if (string === '' || typeof string === 'undefined') {
      return null;
    } else {
      return string;
    }
  },

  isAdmin(role){
    const roles = Array.isArray(role) ? role : [role];
    return roles.some(r => ["admin", "manager"].includes(r));
  },

  mapDropdownOptions(optionsList, className) {
    return optionsList.map(option =>
      <option value={option.value}
              key={option.value}
              className={className}>
        {option.label}
      </option>
    );
  },

  renderSelect(mappedOptionsList, className, onChangeAction, defaultLabel, defaultValue) {
    return (
      <span className={className}>
        <select
          onChange={onChangeAction}
          className="select"
          value={defaultValue}
        >
          <option value="">{defaultLabel}</option>
          {
            mappedOptionsList
          }
        </select>
      </span>
    );
  },

  isArray(array) {
    return array && Array.isArray(array);
  },

  compactArray(array) {
    if (this.isArray(array)) {
      return array.filter(Boolean);
    }
  },

  flattenArray(array) {
    return [].concat.apply([], array);
  },

  validateDateInput(value, allowOnlyPast) {
    const currentDate = moment();
    const valIsNullOrUndefined =
      (value === null || typeof(value) === 'undefined');

    if (!valIsNullOrUndefined) {
      const isPast = value.diff(currentDate, 'days') < 0;
      const isValid = value.toDate() !== 'Invalid Date';
      const isAfterEighteenHundred =
        value.year() >= 1800;
      if (allowOnlyPast) {
        return (isPast && isAfterEighteenHundred && isValid);
      } else {
        return isValid && isAfterEighteenHundred;
      }
    } else {
      return false;
    }
  },

  truncateTitle(title, len) {
    if (title.length > len && len > 10) {
      return `${title.substr(0, len/2)}...${title.substr(title.length - len/2)}`;
    }
    return title;
  },

  disablePageScroll() {
    document.querySelector('html').style.overflowY = 'hidden';
  },

  resumePageScroll() {
    document.querySelector('html').style.overflowY = 'auto';
  }
};
